// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.

export const PATHS = {
  create: "/manifests/create/:tabId",
  createDefaultTab: "target",
  details: "/manifests/details/:id/:tabId",
  detailsDefaultTab: "details",
  edit: "/manifests/edit/:id/:tabId",
  editDefaultTab: "target",
};
